import React from 'react';
import TooltipContent from '../tooltip-content';
import { useDistributedTooltip } from './hooks';
var DistributedChartTooltip = function (_a) {
    var data = _a.data, keys = _a.keys, disabledKeys = _a.disabledKeys, selectors = _a.selectors, isPercentage = _a.isPercentage, isStacked = _a.isStacked, labelSelector = _a.labelSelector, maxWidth = _a.maxWidth, tooltipSettings = _a.tooltipSettings, isTimePrecise = _a.isTimePrecise;
    var _b = useDistributedTooltip({
        data: data,
        keys: keys,
        disabledKeys: disabledKeys,
        selectors: selectors,
        isPercentage: isPercentage,
        isStacked: isStacked,
        labelSelector: labelSelector,
        tooltipSettings: tooltipSettings,
        isTimePrecise: isTimePrecise,
    }), label = _b.label, percentValue = _b.percentValue, totalValue = _b.totalValue, items = _b.items;
    return (React.createElement(TooltipContent, { items: items, label: label, totalValue: totalValue, percentValue: percentValue, maxWidth: maxWidth }));
};
export default DistributedChartTooltip;
